import {Component, Input, OnInit} from '@angular/core';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {Observable, Subject} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {getCurrentProject, ProjectState} from '@features/projects/store/reducers/projects.reducer';
import {CookieService} from 'ngx-cookie-service';
import {ItpDesktopService} from '@core/services/itpdesktopservices/itp-desktop.service';
import {FileManagementService} from '@core/services/file-management.service';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {PlatformCommand, PlatformCommandResponse} from '@shared/commands/command-base';
import {take, takeUntil} from 'rxjs/operators';
import {Configuration} from '@shared/models/configuration';
import {getQueryResponse} from '@shared/store/selectors/query.selector';

@Component({
    standalone: false,
    selector: 'app-itp-luncher',
  templateUrl: './itp-launcher.component.html',
  styleUrls: ['./itp-launcher.component.scss']
})
export class ItpLauncherComponent implements OnInit, IPlatformToolComponent {
  @Input() magicLinkModel: MagicLinkModel;
  @Input() handler: IPlatformToolHandler;
  @Input() selectedTab: TabModel;
  @Input() invalidateSubject: InvalidateSubject = new InvalidateSubject();
  demoHistory$: Observable<any>;
  demoHistory: any;
  protocolUrl: string;
  currentProject: any;
  unSubscribe$ = new Subject<void>();
  toolTipKey3a = 'Open in web/browser';
  isAlreadyAppInstalled: boolean;
  currentRoute = '';
  accessToken: any;
  isDesktop: boolean;
  toolTipKey3c = 'Open in ITP dektop';


  constructor(private projectStore: Store<ProjectState>,
              private cookieService: CookieService,
              private itpDesktopService: ItpDesktopService,
              private fileManagementService: FileManagementService,
              private commandService: CommandService,
              private router: Router ) { }

  ngOnInit(): void {
  }


  runProtocolDesktop() {
    location.href = this.protocolUrl;
  }

  runProtocolWeb() {
    const calculatorWebLinkCommand = new PlatformCommand('CalculatorWebLinkCommand', 'SpreadsheetApi');
    this.commandService.executePlatformCommand(calculatorWebLinkCommand).pipe(take(1)).subscribe(commandResponse => {

    });

  }

  detectedProtocol() {
    this.isAlreadyAppInstalled = true;
  }
  download() {
    const a = document.createElement('a');
    a.setAttribute('href', Configuration.getConfig('DesignerProUrl'));
    a.setAttribute('target', '_blank');
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  onLoad() {

    this.projectStore.select(getCurrentProject).pipe(takeUntil(this.unSubscribe$)).subscribe(project => {
      this.currentProject = project;
    });

    this.currentRoute = this.router.url;
    console.log('route  : ' + this.router.url);
    this.isAlreadyAppInstalled = true;
    this.protocolUrl = null;
    this.isDesktop = this.itpDesktopService.isDesktop();

    this.demoHistory$ = this.projectStore.pipe(select(getQueryResponse, 'MyDemo'));
    this.demoHistory$.subscribe(state => {
      this.demoHistory = state;
    });
    const desktopTokenId = this.selectedTab.tabData['DesktopTokenId'];
    const scenarioId = this.selectedTab.tabData['ScenarioId'];
    const openExtractor = this.selectedTab.tabData['OpenExtractor'];
    const startAsEat = this.selectedTab.tabData['StartAsEat'];
    const scenarioType = this.selectedTab.tabData['ScenarioType'];
    const flowExecutionId = this.selectedTab.tabData['FlowExecutionId'];
    this.isAlreadyAppInstalled = false;
    this.protocolUrl = `itp://app=ITPDesktop&id=${desktopTokenId}&cluster=${Configuration.getConfig('DesktopCluster')}&releaseType=${Configuration.getConfig('DesktopReleaseType')}&scenarioId=${scenarioId}&openExtractor=${openExtractor}&startAsEat=${startAsEat}`;
    console.log(`platformLinkId: ${flowExecutionId}`);
    console.log('>>>>>##>>>>>>');
    console.log(this.selectedTab);
    if (flowExecutionId) {
      this.protocolUrl = this.protocolUrl.concat(`&flowExecutionId=${flowExecutionId}`);
    }
    if (scenarioType) {
      this.protocolUrl = this.protocolUrl.concat(`&scenarioType=${scenarioType}`);
    }
    console.log(`>>>>>> protocolUrl`);
    console.log(this.protocolUrl);
    if (!this.itpDesktopService.isDesktop()) {
      this.runProtocolDesktop();
    }
  }

  onBeforeExecuteNextCommand(): boolean {
    return false;
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {

  }

  onBeforeExecutePreviousCommand(): boolean {
    return false;
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {

  }

}
